module.exports = __webpack_public_path__ + "static/media/chicken10.31238cd7.jpg";